import { Link } from "react-router-dom";
import { useConsent, setConsent } from "@/lib/adConsent";
import { adsConfigured } from "@/components/AdSlot";

/**
 * Cookie/ad-consent banner. Only shown once AdSense is actually configured and the
 * visitor hasn't made a choice yet. For EEA/UK/Switzerland traffic you should replace
 * this with a Google-certified IAB-TCF CMP before serving personalized ads.
 */
export default function ConsentBanner() {
    const consent = useConsent();
    if (!adsConfigured()) return null;   // nothing to consent to yet
    if (consent) return null;            // already chose

    const choose = (v) => setConsent(v);

    return (
        <div role="dialog" aria-live="polite" data-testid="ad-consent-banner"
            className="fixed bottom-0 inset-x-0 z-[9998] border-t border-[#2a2a2a] bg-[#141414]/95 backdrop-blur-sm p-4 pb-20 sm:pb-4">
            <div className="max-w-5xl mx-auto flex flex-col sm:flex-row sm:items-center gap-3">
                <p className="text-xs text-[#a0a0a0] flex-1 leading-relaxed">
                    We and our partner <strong className="text-[#cfcfcf]">Google</strong> use cookies to show ads that keep
                    TravelSports.info free. Choose <strong className="text-[#cfcfcf]">Accept</strong> for personalized ads,
                    <strong className="text-[#cfcfcf]"> Non-personalized</strong> for contextual ads only, or
                    <strong className="text-[#cfcfcf]"> Reject</strong> to decline advertising cookies. See our{" "}
                    <Link to="/privacy" className="text-[#ff4500] hover:underline">Privacy Policy</Link>.
                </p>
                <div className="flex items-center gap-2 shrink-0">
                    <button type="button" data-testid="consent-accept" onClick={() => choose("personalized")}
                        className="px-3 py-2 text-[10px] font-semibold uppercase tracking-[0.15em] text-white bg-[#ff4500] hover:bg-[#ff6a33]">
                        Accept
                    </button>
                    <button type="button" data-testid="consent-nonpersonalized" onClick={() => choose("non-personalized")}
                        className="px-3 py-2 text-[10px] uppercase tracking-[0.15em] text-[#cfcfcf] border border-[#2a2a2a] hover:text-white">
                        Non-personalized
                    </button>
                    <button type="button" data-testid="consent-reject" onClick={() => choose("rejected")}
                        className="px-3 py-2 text-[10px] uppercase tracking-[0.15em] text-[#a0a0a0] hover:text-white">
                        Reject
                    </button>
                </div>
            </div>
        </div>
    );
}
